import React, { useState } from 'react';
import {
  TextField,
  TextFieldProps,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useField } from 'formik';
import { Visibility, VisibilityOff } from '@mui/icons-material';

type FormTextFieldProps = {
  name: string;
  type?: string;
} & Omit<TextFieldProps, 'name'>;

export const FormTextField: React.FC<FormTextFieldProps> = ({
  name,
  type = 'text',
  ...props
}) => {
  const [field, meta] = useField(name);
  const [show, setShow] = useState(false);

  const isPassword = type === 'password';
  const inputType = isPassword && !show ? 'password' : 'text';

  // build your slotProps only for password fields
  const slotProps = isPassword
    ? {
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShow((prev) => !prev)}
                edge="end"
                aria-label={show ? 'Hide password' : 'Show password'}
              >
                {show ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }
    : undefined;

  return (
    <TextField
      {...field}
      {...props}
      type={inputType}
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
      fullWidth
      size="small"
      slotProps={slotProps}
    />
  );
};
